export enum FeedbackStatus {
    DEFAULT = 'default',
    LIKE = 'like',
    DISLIKE = 'dislike',
}

export enum FeedbackSuffix {
    LIKE = 'T',
    DISLIKE = 'F',
}